<template>
    <div class="m-1">

        <!-- Alert: No item found -->
        <b-alert
                variant="danger"
                :show="userData === undefined"
        >
            <h4 class="alert-heading">
                Error fetching user data
            </h4>
            <div class="alert-body p-3">
                No user found with this user id. Check
                <b-link
                        class="alert-link"
                        :to="{ name: 'apps-users-list'}"
                >
                    User List
                </b-link>
                for other users.
            </div>
        </b-alert>

        <div v-if="userData === null" class="mt-4 d-flex align-items-center justify-content-center">
            <b-spinner class=""></b-spinner>
        </div>

        <template v-if="userData">
            <!-- First Row -->
            <b-row>
                <b-col
                        cols="12"
                        xl="12"
                        lg="12"
                        md="12"
                >
                    <user-view-user-info-card :user-data="userData" />
                </b-col>
            </b-row>

            <b-row>
                <b-col
                        cols="12"
                        lg="12"
                >
                    <!-- <user-view-user-permissions-card /> -->
                </b-col>
            </b-row>

        </template>

    </div>
</template>

<script>
  import { BAlert, BCol, BLink, BRow, BSpinner } from 'bootstrap-vue'
  // import InvoiceList from '@/views/apps/invoice/invoice-list/InvoiceList.vue'
  import UserViewUserInfoCard from './UserViewUserInfoCard.vue'
  import { mapActions } from 'vuex'

  export default {
    components: {
      BRow,
      BCol,
      BAlert,
      BLink,
      BSpinner,
      // Local Components
      UserViewUserInfoCard,
      // InvoiceList,
    },

    data(){
      return{
        userData : null
      }
    },
    methods: {
      ...mapActions('user', ['users', 'destroy', 'update','show']),
      ...mapActions('role', ['roles']),
    },
    async mounted() {
      //TODO
      const show = await this.show(this.$router.currentRoute.params.id)
      if (show)
        this.userData= show.data
    }
  }
</script>

<style>

</style>
